export class Model_CRM_Assigne
{  
        public  EmployeeId : number;
        public  EmployeeName : string;
 }       